import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
render(<HelmetProvider data-id="element-350">
    <App data-id="element-351" />
  </HelmetProvider>, document.getElementById('root'));